import { render, staticRenderFns } from "./Classroom.vue?vue&type=template&id=6666051c&scoped=true&"
import script from "./Classroom.vue?vue&type=script&lang=ts&"
export * from "./Classroom.vue?vue&type=script&lang=ts&"
import style0 from "./Classroom.vue?vue&type=style&index=0&id=6666051c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6666051c",
  null
  
)

export default component.exports